export const WHO_ARE_YOU_OPTIONS = [
  { name: "Brand", value: "brand" },
  { name: "Agency", value: "agency" },
  { name: "Creator", value: "creator" },
  { name: "Service Provider", value: "service_provider" },
];

export const SUPPORT_URL = "https://inspirationco.freshdesk.com/support/tickets/new";
